
interface IPaymentLogo {
  image: string;
  alt: string;
}

export const PaymentLogo = ({ image, alt }: IPaymentLogo) => {
  return <img className={'h-[35px] md:h-[30px]'} src={image} alt={alt} />;
};